import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ApiTownPlanningConstants } from "../../../shared/constants/api-constants/api-town-planning.constants";
import { ApiAdminConstants } from "../../../shared/constants/api-constants/api-admin.constants";
import { ApiAssemblyVersionConstants } from "../../../shared/constants/api-constants/api-assembly-version.constants";
let ApplicationService = class ApplicationService {
    http;
    selectedApplicationSubject = new BehaviorSubject(null);
    $selectedApplicationSubject = this.selectedApplicationSubject.asObservable();
    constructor(http) {
        this.http = http;
    }
    submitAdhocFeedbackRequest(adhocFeedback) {
        return this.http.post(`${ApiAdminConstants.URL}/${ApiAdminConstants.FUNCTION_SEND_FEEDBACK_TO_AFLA}`, adhocFeedback);
    }
    getAssemblyVersion() {
        return this.http.get(`${ApiAssemblyVersionConstants.URL}`);
    }
    getTownPlanningApplicationRequest(appId) {
        const params = {
            $expand: "createdSystemUser,applicant,applicantAgent,properties,applicationZonings,applicationTypes"
        };
        return this.http.get(`${ApiTownPlanningConstants.URL}/${appId}`, { params });
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ApplicationService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ApplicationService);
export { ApplicationService };
